var calculateOffset = function calculateOffset(_ref) {
  var page = _ref.page,
      perPage = _ref.perPage;
  return page * perPage;
};

export default calculateOffset;
//# sourceMappingURL=calculateOffset.esm.js.map
